<template>
  <section class="products-section" :dir="lang === 'fa' ? 'rtl' : 'ltr'">
    <div class="products-container">
      <div class="products-header">
        <div class="title-wrapper">
          <span class="title-decoration title-decoration-left"> ✦ </span>

          <div class="title-content">
            <h2 class="section-title">
              {{ lang === "fa" ? titleFa : titleEn }}
            </h2>

            <span class="title-line"></span>
          </div>

          <span class="title-decoration title-decoration-right"> ★ </span>
        </div>

        <!-- مشاهده همه -->
        <a
          v-if="linkShowAll"
          :href="`${currentLang.urls.ProductCategory}/${linkShowAll}`"
          class="show-all"
        >
          <span>
            {{ currentLang.showAll }}
          </span>

          <span class="show-all-arrow">
            {{ lang === "fa" ? "←" : "→" }}
          </span>
        </a>
      </div>

      <!-- =========================
           Loading
      ========================== -->
      <div v-if="loading" class="products-loading">
        <div v-for="n in 4" :key="n" class="product-skeleton">
          <div class="skeleton-image"></div>

          <div class="skeleton-line large"></div>

          <div class="skeleton-line"></div>

          <div class="skeleton-line price"></div>
        </div>
      </div>

      <!-- =========================
           Error
      ========================== -->
      <div v-else-if="errorMessage" class="products-error">
        <div class="error-icon">😕</div>

        <p>
          {{ errorMessage }}
        </p>

        <button type="button" @click="getTopProducts">
          {{ currentLang.retry }}
        </button>
      </div>

      <!-- =========================
           Empty
      ========================== -->
      <div v-else-if="!products.length" class="products-empty">
        <span> 📚 </span>

        <p>
          {{ currentLang.empty || "محصولی برای نمایش وجود ندارد." }}
        </p>
      </div>

      <!-- =========================
           Products Carousel
      ========================== -->
      <div v-else class="products-slider-wrapper">
        <!-- Previous Button -->
        <button
          type="button"
          class="slider-button slider-button-prev"
          :aria-label="lang === 'fa' ? 'محصولات قبلی' : 'Previous products'"
          @click="scrollPrev"
        >
          <span>
            {{ lang === "fa" ? "‹" : "›" }}
          </span>
        </button>

        <!-- =========================
             Scroll Area
        ========================== -->
        <div
          ref="scrollRef"
          class="products-slider"
          @mousedown="startDrag"
          @mousemove="onDrag"
          @mouseup="endDrag"
          @mouseleave="endDrag"
          @touchstart="startDrag"
          @touchmove="onDrag"
          @touchend="endDrag"
        >
          <!-- =========================
               Product Card
          ========================== -->
          <article
            v-for="(product, index) in products"
            :key="product.id"
            class="product-card"
          >
            <!-- شماره محصول -->
            <span class="product-number">
              {{ String(index + 1).padStart(2, "0") }}
            </span>

            <!-- =========================
                 Product Image
            ========================== -->

            <a
              class="product-image-wrapper"
              :href="`${currentLang.urls.Product}/${
                lang === 'fa' ? product.slug_fa : product.slug_en
              }`"
              draggable="false"
            >
              <div class="image-background"></div>

              <img
                :src="product.image"
                :alt="lang === 'fa' ? product.name_fa : product.name_en"
                class="product-image"
                loading="lazy"
                draggable="false"
              />

              <span v-if="product.stock > 5" class="stock-badge">
                {{ currentLang.stock + " " + product.stock }}
              </span>

              <!-- موجودی کم -->
              <span
                v-if="product.stock > 0 && product.stock <= 5"
                class="stock-badge limited"
              >
                {{ currentLang.limited || "تعداد محدود" }}
              </span>

              <!-- ناموجود -->
              <span v-if="product.stock <= 0" class="stock-badge unavailable">
                {{ currentLang.unavailable || "ناموجود" }}
              </span>
            </a>

            <!-- =========================
                 Product Content
            ========================== -->
            <div class="product-content">
              <!-- Category -->
              <span class="product-category">
                {{ product.category }}
              </span>

              <!-- Name -->
              <a
                :href="`${currentLang.urls.Product}/${
                  lang === 'fa' ? product.slug_fa : product.slug_en
                }`"
                class="product-name"
              >
                {{ lang === "fa" ? product.name_fa : product.name_en }}
              </a>

              <!-- =========================
                   Price + Button
              ========================== -->
              <div class="product-bottom">
                <div class="product-price">
                  <span class="price-label">
                    {{ currentLang.price }}
                  </span>

                  <strong>
                    {{ formatPrice(product.price) }}
                  </strong>
                </div>

                <button
  v-if="!isInCart(product.id)"
  type="button"
  class="product-button"
  :disabled="product.stock <= 0"
  @click="handleAddToCart(product)"
  :aria-label="
    lang === 'fa'
      ? `افزودن ${product.name_fa} به سبد خرید`
      : `Add ${product.name_en} to cart`
  "
>
  <span>
    <i class="bi bi-cart fs-5 position-relative"></i>
  </span>
</button>

<button
  v-else
  type="button"
  class="product-button remove"
  @click="handleRemoveFromCart(product)"
  :aria-label="
    lang === 'fa'
      ? `حذف ${product.name_fa} از سبد خرید`
      : `Remove ${product.name_en} from cart`
  "
>
  <span>
    <i class="bi bi-trash fs-5 position-relative"></i>
  </span>
</button>




    

              </div>
            </div>
          </article>
        </div>

        <!-- Next Button -->
        <button
          type="button"
          class="slider-button slider-button-next"
          :aria-label="lang === 'fa' ? 'محصولات بعدی' : 'Next products'"
          @click="scrollNext"
        >
          <span>
            {{ lang === "fa" ? "›" : "‹" }}
          </span>
        </button>
      </div>

      <!-- =========================
           Mobile Hint
      ========================== -->
      <div v-if="products.length > 1" class="scroll-hint">
        <span class="hint-dot"></span>

        <span>
          {{
            lang === "fa"
              ? "برای دیدن محصولات بیشتر بکشید"
              : "Swipe to see more"
          }}
        </span>

        <span class="hint-arrow">
          {{ lang === "fa" ? "←" : "→" }}
        </span>
      </div>
    </div>
  </section>
</template>


<script setup>
import { ref, onMounted, computed } from "vue";
import api from "@/plugins/axios";
import { lang } from "@/plugins/lang";
import enAuth from "@/locales/en/listProducts";
import faAuth from "@/locales/fa/listProducts";
import { useCart } from "@/stores/cart";

const translations = {
  en: enAuth,
  fa: faAuth,
};
const currentLang = computed(() => translations[lang.value]);

const products = ref([]);
const loading = ref(false);
const errorMessage = ref("");
const titleFa = ref("");
const titleEn = ref("");
const linkShowAll = ref("");

const props = defineProps({
  sectionId: {
    type: Number,
    required: true,
  },
});



const { addToCart, isInCart, removeFromCart } = useCart();

const handleAddToCart = (product) => {
  if (!product || isInCart(product.id)) return

  const result = addToCart(product.id, 1, product.stock,product.price)

  if (!result.success) {
    alert(result.message)
  }
}

const handleRemoveFromCart = (product) => {
  if (!product) return

  const result = removeFromCart(product.id)

  if (!result.success) {
    alert(result.message)
  }
}



/*
|--------------------------------------------------------------------------
| دریافت چهار محصول برتر
|--------------------------------------------------------------------------
*/
const getTopProducts = async () => {
  loading.value = true;
  errorMessage.value = "";

  try {
    const response = await api.get(
      `/general/home-page-Sections/${props.sectionId}`
    );

    /*
     * طبق ساختار پاسخ API:
     * {
     *   data: [],
     *   success: true
     * }
     */
    if (response.data?.success) {
      products.value = response.data.data.products || [];
      titleFa.value = response.data.data.title_fa || "";
      titleEn.value = response.data.data.title_en || "";
      linkShowAll.value = response.data.data.category.slug || "";
    } else {
      products.value = [];
      errorMessage.value =
        response.data?.message || "دریافت محصولات با خطا مواجه شد.";
    }
  } catch (error) {
    console.error("Error fetching products:", error);

    products.value = [];
    errorMessage.value =
      error.response?.data?.message ||
      "خطا در ارتباط با سرور. لطفاً دوباره تلاش کنید.";
  } finally {
    loading.value = false;
  }
};

const formatPrice = (price) => {
  if (price === null || price === undefined)
    return "۰ {{currentLang.value.toman}}";

  return `${Number(price).toLocaleString("fa-IR")} ${currentLang.value.toman}`;
};

const scrollRef = ref(null);

let isDown = false;
let startX = 0;
let scrollLeft = 0;

const getScrollAmount = () => {
  const el = scrollRef.value;

  if (!el) return 300;

  return Math.max(260, Math.min(360, el.clientWidth * 0.75));
};

const scrollNext = () => {
  scrollRef.value?.scrollBy({
    left: getScrollAmount(),
    behavior: "smooth",
  });
};

const scrollPrev = () => {
  scrollRef.value?.scrollBy({
    left: -getScrollAmount(),
    behavior: "smooth",
  });
};

const startDrag = (e) => {
  isDown = true;

  const el = scrollRef.value;

  if (!el) return;

  el.classList.add("dragging");

  startX = e.pageX || e.touches?.[0]?.pageX || 0;
  scrollLeft = el.scrollLeft;
};

const onDrag = (e) => {
  if (!isDown) return;

  e.preventDefault();

  const el = scrollRef.value;

  if (!el) return;

  const x = e.pageX || e.touches?.[0]?.pageX || 0;
  const walk = (x - startX) * 1.5;

  el.scrollLeft = scrollLeft - walk;
};

const endDrag = () => {
  isDown = false;

  scrollRef.value?.classList.remove("dragging");
};

/*
|--------------------------------------------------------------------------
| اجرای درخواست هنگام ورود کامپوننت
|--------------------------------------------------------------------------
*/
onMounted(() => {
  getTopProducts();
});
</script>




<style scoped>

.product-button.remove {
  background-color: #dc3545;
  color: #fff;
}

.product-button.remove:hover {
  background-color: #bb2d3b;
}

.products-section {
  width: 100%;
  max-width: 100vw;
  overflow-x: clip;
  box-sizing: border-box;
  padding: 40px 0;
}

.products-container {
  width: min(95%, 95vw);
  max-width: 95vw;
  margin: 0 auto;
  min-width: 0;
  box-sizing: border-box;
}

.products-slider-wrapper {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.products-slider {
  display: flex;
  align-items: stretch;

  width: 100%;
  max-width: 100%;
  min-width: 0;

  gap: 20px;

  padding: 10px 5px 25px;

  overflow-x: auto;
  overflow-y: hidden;

  box-sizing: border-box;

  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;

  scrollbar-width: none;

  cursor: grab;
  user-select: none;

  -webkit-overflow-scrolling: touch;

  /* خیلی مهم */
  overscroll-behavior-x: contain;
  touch-action: pan-x;
}

.products-slider::-webkit-scrollbar {
  display: none;
}

.products-slider.dragging {
  cursor: grabbing;
  scroll-behavior: auto;
}

.product-card {
  position: relative;

  display: flex;
  flex-direction: column;

  /* مهم: به جای width:100% */
  flex: 0 0 260px;

  width: 260px;
  min-width: 260px;
  max-width: 260px;

  overflow: hidden;

  background: #fff;
  border: 2px solid #f0f2f8;
  border-radius: 24px;

  box-sizing: border-box;

  scroll-snap-align: start;

  box-shadow: 0 8px 25px rgba(47, 56, 83, 0.08);
}

/* =========================
   Tablet
========================= */

@media (max-width: 1100px) {
  .product-card {
    flex: 0 0 240px;
    width: 240px;
    min-width: 240px;
    max-width: 240px;
  }
}

/* =========================
   Small Tablet
========================= */

@media (max-width: 800px) {
  .products-slider {
    gap: 16px;
  }

  .product-card {
    flex: 0 0 220px;
    width: 220px;
    min-width: 220px;
    max-width: 220px;
  }
}

/* =========================
   Mobile
========================= */

@media (max-width: 600px) {
  .products-section {
    width: 100%;
    max-width: 100vw;

    overflow-x: clip;

    padding: 30px 0;
  }

  .products-container {
    width: 95%;
    max-width: 95vw;

    margin: 0 auto;

    overflow: hidden;
  }

  .products-slider-wrapper {
    width: 100%;
    max-width: 100%;

    overflow: hidden;
  }

  .products-slider {
    width: 100%;
    max-width: 100%;

    gap: 12px;

    padding: 8px 2px 20px;

    overflow-x: auto;
    overflow-y: hidden;

    /* فقط خود این قسمت حرکت کند */
    overscroll-behavior-x: contain;
    touch-action: pan-x;
  }

  .product-card {
    /*
      موبایل:
      کارت حدود 78 درصد عرض لیست است،
      نه 100 درصد صفحه
    */
    flex: 0 0 78%;
    width: 78%;
    min-width: 78%;
    max-width: 78%;

    border-radius: 20px;
  }

  .slider-button {
    display: none;
  }
}

/* =========================================
   HEADER
========================================= */

.products-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  margin-bottom: 25px;
  box-sizing: border-box;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.title-content {
  min-width: 0;
}

.section-title {
  margin: 0;
  color: #18324b;
  font-size: clamp(20px, 2vw, 28px);
  font-weight: 900;
  line-height: 1.5;
}

.title-line {
  display: block;
  width: 60px;
  height: 4px;
  margin-top: 5px;
  border-radius: 50px;
  background: linear-gradient(90deg, #ffcf4a, #ff8e9e, #78c8ff);
}

.title-decoration {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 34px;
  height: 34px;

  flex: 0 0 34px;

  border-radius: 50%;

  font-size: 16px;
}

.title-decoration-left {
  color: #ff9b42;
  background: #fff0d9;
}

.title-decoration-right {
  color: #8066e8;
  background: #eeeaff;
}

/* =========================================
   SHOW ALL
========================================= */

.show-all {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  flex: 0 0 auto;

  padding: 9px 15px;

  color: #59647f;
  background: #fff;

  border: 2px solid #edf0f7;
  border-radius: 50px;

  text-decoration: none;

  font-size: 13px;
  font-weight: 800;

  box-sizing: border-box;
}

.show-all-arrow {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 22px;
  height: 22px;

  color: #fff;
  background: #ff9d55;

  border-radius: 50%;
}

/* =========================================
   CAROUSEL WRAPPER
========================================= */

.products-slider-wrapper {
  position: relative;

  width: 100%;
  max-width: 100%;
  min-width: 0;

  overflow: hidden;

  box-sizing: border-box;
}

/* =========================================
   CAROUSEL
========================================= */

.products-slider {
  display: flex;
  align-items: stretch;

  width: 100%;
  max-width: 100%;
  min-width: 0;

  gap: 20px;

  padding: 10px 8px 25px;

  overflow-x: auto;
  overflow-y: hidden;

  box-sizing: border-box;

  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;

  scrollbar-width: none;

  cursor: grab;

  user-select: none;

  -webkit-overflow-scrolling: touch;
}

.products-slider::-webkit-scrollbar {
  display: none;
}

.products-slider.dragging {
  cursor: grabbing;
  scroll-behavior: auto;
}

/* =========================================
   PRODUCT CARD
========================================= */

.product-card {
  position: relative;

  display: flex;
  flex-direction: column;

  /*
   * مهم:
   * کارت هیچ‌وقت نباید از این مقدار بیشتر شود.
   */
  flex: 0 0 calc((100% - 60px) / 4);

  width: calc((100% - 60px) / 4);
  min-width: 0;
  max-width: calc((100% - 60px) / 4);

  overflow: hidden;

  background: #fff;

  border: 2px solid #f0f2f8;
  border-radius: 25px;

  box-sizing: border-box;

  scroll-snap-align: start;

  box-shadow: 0 8px 25px rgba(47, 56, 83, 0.08);

  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.product-card:hover {
  transform: translateY(-5px);

  border-color: #ffe08b;

  box-shadow: 0 15px 35px rgba(47, 56, 83, 0.13);
}

/* =========================================
   PRODUCT IMAGE
========================================= */

.product-image-wrapper {
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 220px;

  padding: 15px;

  overflow: hidden;

  box-sizing: border-box;

  text-decoration: none;
}

.image-background {
  position: absolute;

  inset: 8px;

  border-radius: 19px;

  background: linear-gradient(135deg, #fff5cf, #eef9ff 50%, #f5efff);
}

.image-background::before {
  content: "✦";

  position: absolute;

  top: 12px;
  right: 18px;

  color: rgba(255, 179, 67, 0.45);

  font-size: 22px;
}

.image-background::after {
  content: "●";

  position: absolute;

  bottom: 15px;
  left: 18px;

  color: rgba(255, 179, 67, 0.4);

  font-size: 12px;
}

.product-image {
  position: relative;
  z-index: 1;

  display: block;

  width: 100%;
  height: 100%;

  max-width: 100%;
  min-width: 0;

  object-fit: contain;

  pointer-events: none;

  filter: drop-shadow(0 8px 9px rgba(38, 47, 69, 0.12));

  transition: transform 0.3s ease;
}

.product-card:hover .product-image {
  transform: scale(1.05) rotate(-1deg);
}

/* =========================================
   PRODUCT NUMBER
========================================= */

.product-number {
  position: absolute;

  top: 12px;
  left: 12px;

  z-index: 5;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 31px;
  height: 31px;

  color: #6e678a;
  background: rgba(255, 255, 255, 0.92);

  border-radius: 50%;

  font-size: 10px;
  font-weight: 900;

  box-shadow: 0 4px 10px rgba(45, 51, 75, 0.1);
}

/* =========================================
   CONTENT
========================================= */

.product-content {
  display: flex;
  flex-direction: column;

  flex: 1;

  width: 100%;
  min-width: 0;

  padding: 15px 16px 17px;

  box-sizing: border-box;
}

.product-category {
  display: block;

  width: 100%;
  max-width: 100%;

  margin-bottom: 6px;

  overflow: hidden;

  color: #9299aa;

  font-size: 10px;
  font-weight: 700;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-name {
  display: -webkit-box;

  width: 100%;
  min-width: 0;
  min-height: 45px;

  overflow: hidden;

  color: #18324b;

  text-decoration: none;

  font-size: 14px;
  font-weight: 900;

  line-height: 1.6;

  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.product-name:hover {
  color: #ef8a4d;
}

/* =========================================
   PRICE
========================================= */

.product-bottom {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  width: 100%;
  min-width: 0;

  gap: 8px;

  margin-top: 13px;

  box-sizing: border-box;
}

.product-price {
  display: flex;
  flex-direction: column;

  min-width: 0;
  max-width: calc(100% - 48px);
}

.price-label {
  color: #a0a6b6;

  font-size: 9px;
  font-weight: 700;
}

.product-price strong {
  display: block;

  max-width: 100%;

  overflow: hidden;

  color: #e87549;

  font-size: 12px;
  font-weight: 900;

  text-overflow: ellipsis;
  white-space: nowrap;
}

/* =========================================
   PRODUCT BUTTON
========================================= */

.product-button {
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 0 0 38px;

  width: 38px;
  height: 38px;

  color: #fff;
  background: #ff9b58;

  border-radius: 12px;
  border: none;
    outline: none;
  text-decoration: none;

  box-sizing: border-box;
  

  transition: transform 0.25s ease, border-radius 0.25s ease;
}

.product-button span {
  font-size: 22px;
  line-height: 1;
}

.product-button:hover {
  border-radius: 50%;
  transform: rotate(10deg) scale(1.05);
}

/* =========================================
   STOCK BADGE
========================================= */

.stock-badge {
  position: absolute;

  right: 14px;
  bottom: 13px;

  z-index: 4;

  padding: 5px 8px;

  border-radius: 20px;

  font-size: 9px;
  font-weight: 800;
}

.stock-badge.limited {
  color: #9b6516;
  background: #fff0bf;
}

.stock-badge.unavailable {
  color: #a84d59;
  background: #ffe1e5;
}

/* =========================================
   NAVIGATION BUTTONS
========================================= */

.slider-button {
  position: absolute;

  top: 50%;

  z-index: 10;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 42px;
  height: 42px;

  padding: 0;

  color: #59627d;
  background: #fff;

  border: 2px solid #edf0f6;
  border-radius: 50%;

  box-shadow: 0 7px 20px rgba(40, 47, 70, 0.15);

  cursor: pointer;

  transform: translateY(-50%);

  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.slider-button:hover {
  transform: translateY(-50%) scale(1.08);

  box-shadow: 0 10px 25px rgba(40, 47, 70, 0.2);
}

.slider-button span {
  font-size: 28px;
  line-height: 1;
}

.slider-button-prev {
  left: 4px;
}

.slider-button-next {
  right: 4px;
}

/* =========================================
   TABLET
========================================= */

@media (max-width: 1100px) {
  .product-card {
    flex-basis: calc((100% - 40px) / 3);
    width: calc((100% - 40px) / 3);
    max-width: calc((100% - 40px) / 3);
  }

  .product-image-wrapper {
    height: 210px;
  }
}

/* =========================================
   SMALL TABLET
========================================= */

@media (max-width: 800px) {
  .products-slider {
    gap: 16px;
  }

  .product-card {
    flex-basis: calc((100% - 16px) / 2);
    width: calc((100% - 16px) / 2);
    max-width: calc((100% - 16px) / 2);
  }

  .product-image-wrapper {
    height: 205px;
  }

  .slider-button {
    width: 38px;
    height: 38px;
  }
}

/* =========================================
   MOBILE
========================================= */

@media (max-width: 600px) {
  .products-section {
    padding: 30px 0;
  }

  .products-container {
    width: 95%;
    max-width: 95%;
  }

  .products-header {
    margin-bottom: 18px;
  }

  .section-title {
    font-size: 19px;
  }

  .title-decoration {
    width: 29px;
    height: 29px;

    flex-basis: 29px;

    font-size: 13px;
  }

  .show-all {
    padding: 7px 10px;
    font-size: 10px;
  }

  /*
   * موبایل:
   * یک کارت کامل + قسمتی از کارت بعدی
   */
  .products-slider {
    gap: 13px;

    padding: 8px 5px 20px;
  }

  .product-card {
    flex-basis: 78%;
    width: 78%;
    max-width: 78%;

    border-radius: 22px;
  }

  .product-image-wrapper {
    height: 210px;
  }

  .product-content {
    padding: 13px;
  }

  .product-name {
    font-size: 14px;
  }

  .slider-button {
    display: flex;
    width: 38px;
    height: 38px;
    min-width: 38px;
  }

  .slider-button span {
    font-size: 22px;
  }
}

/* =========================================
   VERY SMALL MOBILE
========================================= */

@media (max-width: 380px) {
  .product-card {
    flex-basis: 84%;
    width: 84%;
    max-width: 84%;
  }

  .product-image-wrapper {
    height: 195px;
  }
}
</style>